import React, {useCallback, useEffect, useState} from 'react';
import {PartnerList} from "../../../components/admin/partner/PartnerList";
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../types/PaginationType";
import {ApiQueryParam, ApiService} from "../../../service/ApiService";
import {partnerResultCollectionType, partnerResultType} from "../../../types/Api/PartnerResultType";
import {partnerHydrator} from "../../../models/hydrator/partnerHydrator";
import {partner} from "../../../models/partner";
import {Pagination} from "../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState([] as partner[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findPartner = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'label',
      direction: 'ASC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<partnerResultCollectionType> = ApiService.get('/partner', apiFilters) as Promise<partnerResultCollectionType>;

    result
      .then((r: partnerResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setPartners(r._embedded.partners.map((partner: partnerResultType) => {
          return partnerHydrator.hydrate(partner);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setPartners([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findPartner();
  }, [findPartner]);

  return (
    <>
      <BoxTitle title="Gestion des partenaires"/>
      <PartnerList partners={partners} loading={loading} refresh={findPartner}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/partner/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un partenaire
        </NavLink>
      </div>
    </>
  )
}